import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { LettingFeatureAdmin } from '../../model/letting-feature-admin';

@Injectable()
export class LettingFeatureAdminService extends DataService<LettingFeatureAdmin> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, LettingFeatureAdmin, progressBar, 'letting-feature');
  }

  add(model: LettingFeatureAdmin, options: { notifyUser: boolean } = { notifyUser: true }) {
    return super.add(model, options).pipe(map(response => response.id));
  }

  deleteMany(ids: string[]) {
    this.progressBar.start();
    return this.client.post(`${this.endpoint}/delete`, JSON.stringify(ids)).pipe(
      map(() => undefined),
      catchError(error => {
        this.notification.showError(error);
        return EMPTY;
      }),
      finalize(() => this.progressBar.stop())
    );
  }
}
